import React from 'react';
import './PostPage.css';

const PostPage = ({ id, title, author, content }) => {


    return (
        <div className='post-con'>
            <div className={`${id} post-img`}></div>
            <div className='post-title'>{title}</div>
            <div className='post-author'>{author}</div>
            <div className='post-content'>{content}</div>
        </div>
    );
};

export default PostPage;
